module.exports = __webpack_public_path__ + "img/sereniby.da7544d8.png";